import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_REF_TASK_LIST = "GET_REF_TASK_LIST";

export const service = async (data) => {
  const options: object = {
    url: `/Api/RefTask/GetRefTaskList`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_REF_TASK_LIST, service, mock);
